<mat-dialog-content>
  <h2 i18n="@@consent.about-google-analytics.title">About Google Analytics</h2>
  <p i18n="@@consent.about-google-analytics.text">
    We use Google Analytics, a web analytics service provided by Google Ireland Limited.
    <br /><br />
    Google Analytics uses cookies and similar technologies to collect information about how visitors use our website.
    <br /><br />
    The collected information may be processed by Google in countries outside the European Economic Area, including
    the United States.
    <br /><br />
    For more information about how Google processes personal data, please refer to our Privacy Policy.
  </p>
</mat-dialog-content>
<mat-dialog-actions align="center">
  <button mat-button type="button" mat-dialog-close i18n="@@consent.close.label">Close</button>
</mat-dialog-actions>
